module.exports = __webpack_public_path__ + "img/prize-btn.5a72be04.gif";